<template>
  <div v-if="data !== null && data.length > 0" class="l-section">
    <h2 class="l-section__title">
      延伸閱讀
    </h2>
    <ul id="article-extended" class="e-list" :style="{minHeight: isMobile ? '430px' : '330px'}">
      <template v-for="(article, index) in data">
        <!-- 第七則原生廣告 -->
        <li :key="article.url">
          <nuxt-link v-if="article.url" :to="`${article.url}/`" class="e-list__link" title="前往新聞頁面">
            {{ article.title }}
          </nuxt-link>
        </li>
        <li v-if="index === 3 && latestTopic" :key="index">
          <nuxt-link :to="`/topic/${latestTopic.topic_id}/`" class="e-list__link" title="前往專題頁面">
            更多最新熱門議題：{{ latestTopic.title }}
          </nuxt-link>
        </li>
        <client-only v-if="index === data.length - 1" :key="article.url">
          <li id="div-gpt-ad-1634030369427-0" ref="div-gpt-ad-1634030369427-0" style="min-height: 20px;" />
          <div id="_popIn_recommend_word_2nd" ref="_popIn_recommend_word_2nd" style="min-height: 30px;" />
        </client-only>
        <!-- 第七則原生廣告 -->
      </template>
      <!-- <div id="_popIn_recommend_word" ref="_popIn_recommend_word" style="min-height: 60px;" /> -->
      <div id="dablewidget_goPLzkEo_GokzxLrX" data-widget_id-pc="goPLzkEo" data-widget_id-mo="GokzxLrX" style="min-height: 60px; height: auto; overflow: visible; margin-left: -20px;" />
      <li id="div-gpt-ad-1584587150345-0" ref="div-gpt-ad-1584587150345-0" style="min-height: 20px;" />
      <li>
        投訴爆料專線：
        <a class="extended-gossip" href="tel:+886-2-66308641" tabindex="-1" title="撥打電話 +886-2-66308641">
          (02)6630-8641
        </a>
        、投訴爆料信箱：
        <a class="extended-gossip" href="mailto:119@ctwant.com" tabindex="-1" title="開啟爆料信箱 119@ctwant.com">
          119@ctwant.com
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import adTabIndexRemove from '@/utils/adTabIndexRemove.js'
export default {
  name: 'ExtendedArticle',
  mixins: [adTabIndexRemove],
  props: {
    initData: {
      required: true,
      type: Array,
      default() {
        return []
      }
    },
    latestTopic: {
      required: false,
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    ...mapGetters([
      'isMobile'
    ]),
    data() {
      const reviseData = [...this.initData]
      // reviseData.push('1584587150345')
      return reviseData
    }
  }
  // mounted() {
  //   this.$nextTick(() => {
  //     if (this.isMobile === false) {
  //       this.$_adTabIndexRemoveFn([
  //         this.$refs['div-gpt-ad-1634030369427-0'][0], // it's <li>
  //         this.$refs['div-gpt-ad-1584587150345-0']
  //       ])
  //       this.$_adTabIndexRemoveFromTagA([
  //         this.$refs._popIn_recommend_word_2nd[0],
  //         this.$refs._popIn_recommend_word
  //       ])
  //     }
  //   })
  // }
}
</script>

<style lang="scss" scoped>
.extended-gossip{
  color: $primary;
  text-decoration: underline;
}
</style>
